<template>
    <div class="settings">
        <h3>{{username}}</h3>
        <p class="settingsitem" v-on:click="logout()">            
            <font-awesome-icon icon="sign-out-alt" />
            <span>Abmelden</span>                        
        </p>        
        <p class="settingsitem" v-on:click="deletePostlist()">            
            <font-awesome-icon icon="trash-alt" />
            <span>Heruntergeladene Beiträge löschen</span>                        
        </p>        
        <p class="settingsitem" v-on:click="deleteCache()">            
            <font-awesome-icon icon="trash-alt" />
            <span>Alle Daten löschen</span>                        
        </p>        
        <p class="settingsitem" v-on:click="resizeFont(2)">
            <font-awesome-icon icon="plus" />
            <span>Schrift vergrößern</span>
        </p>        
        <p class="settingsitem" v-on:click="resizeFont(-2)">
            <font-awesome-icon icon="minus" />
            <span>Schrift verkleinern</span>
        </p>        
        <p id="version">            
            <small>Version {{version}}</small>
        </p>        
    </div>    
</template>

<script>
import MS_CONST from '../msclasses/msconst.js'

export default {
    name: "Settings",
    props: { 
        message: String, 
        backlink: String
    },
    created() {
        this.$parent.setBacklink(this.backlink);
        this.setUsername();
    },
    data() {
        return {
            username: "",
            version: MS_CONST.VERSION
        };
    },    
    methods: {
        setUsername() {
            var self = this;
            this.$ms.loadCacheLogin(function(login) {
                if (login && login.user)                        
                    self.username = login.user;
                else
                    self.username = "[Nicht angemeldet]";
            });
        },
        logout() {
            var self = this;
            this.$ms.logout(function () {
                self.$router.push('/login');
            });                        
        },
        deletePostlist() {
            // todo: Erfolgsmeldung ausgeben und auf Hauptmenü zurückleiten(?)
            this.$ms.deleteCacheContent();
            this.$notify({
                group: 'information',
                text: 'Beiträge wurden aus dem Speicher entfernt!',
                max: 1,
                duration: 8000 //ms
            });

        },
        deleteCache() {
            // todo: Erfolgsmeldung ausgeben und auf Hauptmenü zurückleiten(?)
            this.$parent.subscritptionChecked = false;
            this.$ms.deleteCacheAll();
            this.$notify({
                group: 'information',
                text: 'Alle Daten wurden aus dem Speicher entfernt!',
                max: 1,
                duration: 8000 //ms
            });

        },
        resizeFont(factor) {            
            let element = document.getElementById('app');
            let style = window.getComputedStyle(element, null).getPropertyValue('font-size');
            let currentSize = parseFloat(style);
            if (currentSize <= 8 && factor < 0)
                {
                this.$log.info('Font size minimum already reached!');
                this.$notify({
                    group: 'information',
                    type: 'warn',
                    text: 'Die minimale Schriftgröße wurde erreicht!',
                    max: 1,
                    duration: 10000 //ms
                });
                }
            else if (currentSize >= 32 && factor > 0)             
                {
                this.$log.info('Font size maximum already reached!');               
                this.$notify({
                    group: 'information',
                    type: 'warn',
                    text: 'Die maximale Schriftgröße wurde erreicht!',
                    max: 1,
                    duration: 10000 //ms
                });
                }
            else {
                let setSize = currentSize + factor;
                this.$parent.setFontSize(setSize);                            
                this.$ms.saveCacheSetting({[MS_CONST.SETTING_FONTSIZE]: setSize});
            }                      
        }
    }
};
</script>

<style lang="css" src="../assets/css/Settings.css"/>